module.exports = __webpack_public_path__ + "static/favicon-16x16-84b8cada73c46b2974131d3de81e7e47.png";